import Colors from 'constants/Colors';
import React, { useContext } from 'react';
import { AppContext } from '../../../../App.context';
import CustomButton from '../../../common/CustomButton/CustomButton';

export default function PMSButton({ row, actions }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);
  const pmsSelected = actions.getSelectedPms(row.id) || row.pmsIdSuscribed;

  return pmsSelected ? (
    <div>
      <CustomButton
        background={Colors.pmsConnect}
        color={'white'}
        text={translate('setup')}
        onClick={() =>
          row.premium
            ? actions.onConfigurePMSAsPremium(row.id, pmsSelected)
            : actions.onConfigurePMS(row.id, pmsSelected)
        }
      />
    </div>
  ) : null;
}
